<template>
    <v-dialog v-model="dialog" scrollable persistent>
        <v-card>
            <v-card-text :style="`height: ${bodyHeight}px;`" class="testResult_body px-0 py-0">
                <div class="general">
                    <div class="body-header">
                        <div class="header-top">
                            <div class="header-name-wrap">
                                <div class="header-system-wrap">
                                    <BodySystemsSvg :id="currentResult.bodySystemId"/>
                                    <p>{{ currentResult.bodySystemName }}</p>
                                </div>
                                <div class="header-mark-time">
                                    <span>Время прохождения </span>
                                    
                                    <div class="time">
                                        <Timer :time="prettyTime"  />
                                    </div>
                                </div>
                                <div class="header-mark-wrap" :style="`background: ${getScoreColor(currentResult.score)}`">
                                    <span>Количество баллов </span>
                                    <p class="mark">{{ currentResult.score }}</p>
                                </div>
                            </div>
                        </div>
    
                        <div class="container header-bottom">
                            <v-row no-gutters class="box-1">
                                <v-col cols="12" md="4" lg="3" class="cell-label">Дисциплина</v-col>
                                <v-col cols="12" md="8" lg="9" class="cell-value">{{ currentResult.subject }}</v-col>
                            </v-row>
                            <v-row no-gutters class="box-2">
                                <v-col cols="12" md="4" lg="3" class="cell-label">Тема</v-col>
                                <v-col cols="12" md="8" lg="9" class="cell-value">{{ currentResult.topic }}1</v-col>
                            </v-row>
                            <v-row no-gutters class="box-3">
                                <v-col cols="12" md="5" class="cell-label">Дата прохождения</v-col>
                                <v-col cols="12" md="7" class="cell-input">
                                    <v-select
                                        label=""
                                        :items="results"
                                        item-value="id"
                                        hide-details
                                        item-text="passDate"
                                        variant="outlined"
                                        class="pass-date"
                                        :value="currentResult"
                                        @change="setCurrentResult"
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
    
                    <div class="body-container">
                        <h2>Вопросы</h2>
                        <div class="body-test">
                            <div class="body-item" v-for="(question, questionIndex) in currentResult.questions" :key="`question_${questionIndex}`">
                                <p class="quest-name">{{ `${questionIndex + 1}. ${question.title}` }}</p>
    
                                <TaskMediaFiles v-if="question.files.length > 0" :files="question.files" :maxWidth="mediaMaxWidth" />
    
                                <ul class="item-answers">
                                    <div v-if="question.questionType === 0">
                                        <div class="item-wrap">
                                            <li v-for="(answer, answerIndex) in question.answers" :key="`answer_${answerIndex}`" :class="{ 'correct': answer.correct }">
                                                <div class="point" :class="{ 'select': answer.selected }"></div>
                                                <div class="answer">{{ answer.title }}</div>
                                                <svg v-show="answer.selected" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M25.2002 8.62192L12.1638 20.6641C11.679 21.112 10.8929 21.112 10.408 20.6641L4.2002 14.9297L5.95603 13.3078L11.2859 18.2312L23.4444 7L25.2002 8.62192Z" :fill="getTickColor(answer)"/>
                                                </svg>
                                            </li>
                                        </div>
                                    </div>
                                    <div v-if="question.questionType === 1">
                                        <div class="item-wrap">
                                            <li v-for="(answer, answerIndex) in question.answers" :key="`answer_${answerIndex}`" :class="{ 'correct': answer.correct }">
                                                <div class="sqr" :class="{ 'selectSqr': answer.selected }">
                                                    <svg class="svgSqr" :class="{ 'sqrSelect': answer.selected }" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0473 6.09257L8.29733 14.8426C7.97189 15.168 7.44425 15.168 7.11882 14.8426L2.95215 10.6759L4.13066 9.4974L7.70807 13.0748L15.8688 4.91406L17.0473 6.09257Z" fill="white"/>
                                                    </svg>
                                                </div>
                                                <div class="answer">{{ answer.title }}</div>
                                                <svg v-show="answer.selected || answer.correct" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M25.2002 8.62192L12.1638 20.6641C11.679 21.112 10.8929 21.112 10.408 20.6641L4.2002 14.9297L5.95603 13.3078L11.2859 18.2312L23.4444 7L25.2002 8.62192Z" :fill="getTickColor(answer)"/>
                                                </svg>
                                            </li>
                                        </div>
                                    </div>
                                    <div v-if="question.questionType === 2">
                                        <div class="item-wrap">
                                            <li v-for="(term, termIndex) in question.terms" :key="`term_${termIndex}`">
                                                <div class="term-answer">{{ term.title }} — <span :class="{ 'correct': term.correct }">{{ term.selectedAnswer }}</span></div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M25.2002 8.62192L12.1638 20.6641C11.679 21.112 10.8929 21.112 10.408 20.6641L4.2002 14.9297L5.95603 13.3078L11.2859 18.2312L23.4444 7L25.2002 8.62192Z" :fill="getTermTickColor(term)"/>
                                                </svg>
                                            </li>
                                        </div>
                                    </div>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </v-card-text>

            <v-card-actions>
                <v-btn block @click="close" class="btn-card">Закрыть</v-btn>
            </v-card-actions>
        </v-card>
        <!-- <div v-show="!loading" class="testResult-container">
            <button class="close" @click.prevent="close">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                    <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </button>
            <div ref="body" class="testResult_body" :style="`height: ${bodyHeight}px`">
                <h1>
                    Результаты теста “{{ currentResult.title }}”
                    <span class="badge" :class="getPassTypeBadgeClass(currentResult)">{{ currentResult.passTypeName }}</span>
                </h1>
                <div class="body-header">
                    <div class="header-top">
                        <div class="header-name-wrap">
                            <div class="header-system-wrap">
                                <BodySystemsSvg :id="currentResult.bodySystemId"/>
                                <p>{{ currentResult.bodySystemName }}</p>
                            </div>
                            <div class="header-mark-time">
                                <span>Время прохождения </span>
                                
                                <div class="time">
                                    <Timer :time="prettyTime"  />
                                </div>
                            </div>
                            <div class="header-mark-wrap" :style="`background: ${getScoreColor(currentResult.score)}`">
                                <span>Количество баллов </span>
                                <p class="mark">{{ currentResult.score }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="container header-bottom">
                        <v-row no-gutters class="box-1">
                            <v-col cols="12" md="4" lg="3" class="cell-label">Дисциплина</v-col>
                            <v-col cols="12" md="8" lg="9" class="cell-value">{{ currentResult.subject }}</v-col>
                        </v-row>
                        <v-row no-gutters class="box-2">
                            <v-col cols="12" md="4" lg="3" class="cell-label">Тема</v-col>
                            <v-col cols="12" md="8" lg="9" class="cell-value">{{ currentResult.topic }}1</v-col>
                        </v-row>
                        <v-row no-gutters class="box-3">
                            <v-col cols="12" md="5" class="cell-label">Дата прохождения</v-col>
                            <v-col cols="12" md="7" class="cell-input">
                                <v-select
                                    label=""
                                    :items="results"
                                    item-value="id"
                                    hide-details
                                    item-text="passDate"
                                    variant="outlined"
                                    class="pass-date"
                                    :value="currentResult"
                                    @change="setCurrentResult"
                                ></v-select>
                            </v-col>
                        </v-row>
                    </div>
                </div>
                <div ref="questions" class="body-container">
                    <h2>Вопросы</h2>
                    <div class="body-test">
                        <div class="body-item" v-for="(question, questionIndex) in currentResult.questions" :key="`question_${questionIndex}`">
                            <p class="quest-name">{{ `${questionIndex + 1}. ${question.title}` }}</p>

                            <TaskMediaFiles v-if="question.files.length > 0" :files="question.files" :maxWidth="mediaMaxWidth" />

                            <ul class="item-answers">
                                <div v-if="question.questionType === 0">
                                    <div class="item-wrap">
                                        <li v-for="(answer, answerIndex) in question.answers" :key="`answer_${answerIndex}`" :class="{ 'correct': answer.correct }">
                                            <div class="point" :class="{ 'select': answer.selected }"></div>
                                            <div class="answer">{{ answer.title }}</div>
                                            <svg v-show="answer.selected" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M25.2002 8.62192L12.1638 20.6641C11.679 21.112 10.8929 21.112 10.408 20.6641L4.2002 14.9297L5.95603 13.3078L11.2859 18.2312L23.4444 7L25.2002 8.62192Z" :fill="getTickColor(answer)"/>
                                            </svg>
                                        </li>
                                    </div>
                                </div>
                                <div v-if="question.questionType === 1">
                                    <div class="item-wrap">
                                        <li v-for="(answer, answerIndex) in question.answers" :key="`answer_${answerIndex}`" :class="{ 'correct': answer.correct }">
                                            <div class="sqr" :class="{ 'selectSqr': answer.selected }">
                                                <svg class="svgSqr" :class="{ 'sqrSelect': answer.selected }" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0473 6.09257L8.29733 14.8426C7.97189 15.168 7.44425 15.168 7.11882 14.8426L2.95215 10.6759L4.13066 9.4974L7.70807 13.0748L15.8688 4.91406L17.0473 6.09257Z" fill="white"/>
                                                </svg>
                                            </div>
                                            <div class="answer">{{ answer.title }}</div>
                                            <svg v-show="answer.selected || answer.correct" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M25.2002 8.62192L12.1638 20.6641C11.679 21.112 10.8929 21.112 10.408 20.6641L4.2002 14.9297L5.95603 13.3078L11.2859 18.2312L23.4444 7L25.2002 8.62192Z" :fill="getTickColor(answer)"/>
                                            </svg>
                                        </li>
                                    </div>
                                </div>
                                <div v-if="question.questionType === 2">
                                    <div class="item-wrap">
                                        <li v-for="(term, termIndex) in question.terms" :key="`term_${termIndex}`">
                                            <div class="term-answer">{{ term.title }} — <span :class="{ 'correct': term.correct }">{{ term.selectedAnswer }}</span></div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M25.2002 8.62192L12.1638 20.6641C11.679 21.112 10.8929 21.112 10.408 20.6641L4.2002 14.9297L5.95603 13.3078L11.2859 18.2312L23.4444 7L25.2002 8.62192Z" :fill="getTermTickColor(term)"/>
                                            </svg>
                                        </li>
                                    </div>
                                </div>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </v-dialog>
 </template>

<script>
import { mapGetters } from 'vuex';
import { helpers } from '@/store/tests';
import TaskMediaFiles from '@/components/TaskMediaFiles.vue';
import BodySystemsSvg from '@/components/Svg/BodySystems.vue';
import Timer from '@/components/Timer/index.vue';
import './index.scss';

export default {
    name: 'TestResultDialog',
    components: { TaskMediaFiles, BodySystemsSvg, Timer },
    data: () => ({
        bodyHeight: 0,
        mediaMaxWidth: 0,
        results: [],
        currentResult: {},
        passTypes: [],
        dialog: false,
        loading: false
    }),
    computed: {
        ...mapGetters({
            apiUrl: 'apiUrl'
        }),
        prettyTime () {
            let hours = 0, minutes = 0, seconds = 0;

            if(this.currentResult.durationTime) {
                hours = this.currentResult.durationTime / 3600  % 24;
                minutes = this.currentResult.durationTime / 60 % 60;
                seconds = this.currentResult.durationTime % 60;
            }

            return `${Math.floor(hours)}:${Math.floor(minutes)}:${Math.floor(seconds)}`
        }
    },
    methods: {
        reset(userId, testId, resultId) {
            this.dialog = true;
            this.loading = false;

            this.loadResults(userId, testId, resultId);
        },
        loadResults(userId, testId, resultId) {
            this.loading = true;

            this.$http.get(`${this.apiUrl}TestTask/GetResults?testId=${testId}&userId=${userId}`)
                .then((result) => {
                    this.results = result.data;
                    this.loading = false;

                    if (resultId !== null && this.results.find(x => x.id === resultId) !== undefined) {
                        this.loadResult(resultId);
                    }
                    else if (this.results.length > 0) {
                        this.loadResult(this.results[0].id);
                    } else {
                        this.$emit('loaded');
                    }
            });
        },
        loadResult(id) {
            this.loading = true;

            this.$http.get(`${this.apiUrl}TestTask/GetResult?id=${id}`)
                .then((result) => {
                    this.currentResult = result.data;

                    this.setSelectedAnswers(this.currentResult);

                    this.loading = false;
                    this.$emit('loaded');

                    // this.$nextTick(() => {
                    //     this.$refs.questions.scrollTop = 0;
                    //     this.setMediaMaxWidth();
                    // });
            });
        },
        setSelectedAnswers(result) {
            result.questions.forEach(question => {
                if (question.questionType === 0 || question.questionType === 1) {
                    question.answers.forEach(answer => {
                        let selectedAnswerIds = question.selectedAnswers.map(x => x.id);
                        answer.selected = selectedAnswerIds.includes(answer.id);
                    });
                }
                else if (question.questionType === 2) {
                    question.terms.forEach(term => {
                        let selectedAnswer = question.selectedTermAnswers.find(x => x.testQuestionTermId === term.id);

                        if (selectedAnswer) {
                            let answer = question.termAnswers.find(x => x.id === selectedAnswer.id);

                            if (answer) {
                                term.correct = term.id == answer.testQuestionTermId;
                                term.selectedAnswer = answer.title;
                            }
                        } else {
                            term.correct = false;
                            term.selectedAnswer = '';
                        }
                    });
                }
            });
        },
        setCurrentResult(id) {
            this.loadResult(id);
        },
        setMediaMaxWidth() {
            let mediaOffset = 40;

            if (window.innerWidth >= 1264) {
                mediaOffset = 96;
            } else if (window.innerWidth >= 600) {
                mediaOffset = 48;
            }

            this.mediaMaxWidth = this.$refs.body.offsetWidth - mediaOffset;
        },
        loadPassTypes() {
            this.$http.get(`${this.apiUrl}TestTask/GetPassTypes`)
                .then((response) => {
                    this.passTypes = response.data;
            });
        },
        getPassTypeId(keyName) {
            let found = this.passTypes.find(x => x.keyName === keyName);

            if (found !== undefined) {
                return found.id;
            }

            return null;
        },
        getPassTypeBadgeClass(result) {
            if (result.passTypeId === this.getPassTypeId('SelfStudy')) {
                return 'badge-selfstudy';
            }

            if (result.passTypeId === this.getPassTypeId('Control')) {
                return 'badge-control';
            }

            return '';
        },
        getScoreColor(score) {
            return helpers.getScoreColor(score);
        },
        getTickColor(answer) {
            return answer.selected === answer.correct ? '#33A56E' : '#EE4040';
        },
        getTermTickColor(term) {
            return term.correct ? '#33A56E' : '#EE4040';
        },
        close() {
            this.dialog = false;
            this.$emit('close');
        }
    },
    created() {
        this.loadPassTypes();

        this.bodyHeight = Math.floor(window.innerHeight * 0.9) - 50;

        if (window.innerWidth < 1264) {
            this.bodyHeight -= 20;
        }
    }
}
</script>
